export default {
  name: 'BoolEditor',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    value: {
      default: 1
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['update:value', 'blur', 'focus'],
  setup(props, context) {
    const handleUpdateValue = value => {
      context.emit('update:value', value);
    };
    return {
      handleUpdateValue
    };
  }
};